/* eslint-disable @typescript-eslint/no-explicit-any */
import { evalCondition as evalConditionV2 } from '@appcraft/common-utils';

// Every form condition is evaluated by the engine of @appcraft/common-utils, with or without
// `version: "2"`: conditions left without a version by the V1 -> V2 migration are read as V2.

export function evalCondition(condition: any, data: any): boolean {
  return evalConditionV2(condition, data);
}

function isGroup(condition: any): boolean {
  return condition.op === 'and' || condition.op === 'or';
}

/** Collects the keys read by a condition (nested `and` / `or` expressions included). */
export function extractConditionFields(condition: any, fields: string[]): string[] {
  if (!condition || typeof condition !== 'object') return fields;

  if (isGroup(condition)) {
    condition.expressions?.forEach((expression: any) => extractConditionFields(expression, fields));
  } else if (condition.key && !fields.includes(condition.key)) {
    fields.push(condition.key);
  }
  return fields;
}

/** Scopes the condition keys of a ListItem child to its item: `key` becomes `name[index][key]` */
export function rewriteListItemCondition(name: string, index: number, condition: any): any {
  if (!condition || typeof condition !== 'object') return condition;

  if (isGroup(condition)) {
    return { ...condition, expressions: condition.expressions?.map((expression: any) => rewriteListItemCondition(name, index, expression)) };
  }
  return { ...condition, key: `${name}[${index}][${condition.key}]` };
}
